// extracted by mini-css-extract-plugin
export default {"root":"src-views-common-components-CountryPicker-PickedCountryCounter-PickedCountryCounter__root--iUc_G"};